import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ResultsDashboard from "@/components/ResultsDashboard";

export default function AnalysisDetailPage() {
  const { id } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getSoundDetail(id)
      .then(r => { setResult(r.data); })
      .catch(() => toast.error("Failed to load analysis"))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="p-8 text-center text-sm text-slate-400">Loading analysis...</div>;
  if (!result || result.error) return (
    <div className="p-8 text-center">
      <p className="text-slate-500">Analysis not found</p>
      <Link to="/history"><Button className="mt-4" variant="outline">Back to History</Button></Link>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Link to="/history">
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0" data-testid="back-btn">
            <ArrowLeft size={16} />
          </Button>
        </Link>
        <div>
          <h1 className="text-2xl font-bold tracking-tight uppercase font-['Barlow']" data-testid="detail-title">
            {result.car_details?.make} {result.car_details?.model} ({result.car_details?.year})
          </h1>
          <p className="text-xs text-slate-400 font-mono">{new Date(result.created_at).toLocaleString()}</p>
        </div>
      </div>
      
      {/* Cache indicator for repeated analyses */}
      {result.from_cache && (
        <div className="flex items-center gap-2 px-3 py-2 bg-emerald-50 border border-emerald-200 rounded-md text-sm text-emerald-700" data-testid="cache-indicator">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-emerald-500">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <path d="m9 12 2 2 4-4"/>
          </svg>
          <span><strong>Instant Result:</strong> This exact configuration was analyzed before. Showing cached result for consistency.</span>
        </div>
      )}
      
      <ResultsDashboard result={result} />
    </div>
  );
}
